// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-delete delete-button\"> <i class=\"fa fa-trash\"></i><span data-bind=\"text: _labels.DELETE\"></span> </a>";
// Exports
export default code;